import React, { useState, useEffect } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import UserSidebar from "./UserSidebar";
import UserTopBar from "./UserTopBar";
import UserContent from "./UserContent";
import { useCustomTheme } from "../../utils/useCustomTheme";
import { TranslateContext } from "../../context/TranslateContext";
import { useHistory, useLocation } from "react-router-dom";

const drawerWidth = 250;

const UserDashboard = () => {
  const theme = useTheme();
  const { lang } = React.useContext(TranslateContext);
  const { toggleColorMode, isDark } = useCustomTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const history = useHistory();
  const location = useLocation();

  // ── Read initial menu from ?page= query param ──────────────────
  const getPageFromUrl = () => {
    const params = new URLSearchParams(location.search);
    return params.get("page") || "dashboard";
  };

  const [selectedMenu, setSelectedMenu] = useState(getPageFromUrl);
  const [mobileOpen, setMobileOpen] = useState(false);

  // ── Sync URL when menu changes ─────────────────────────────────
  const navigateTo = (menuId) => {
    history.replace({ pathname: "/user", search: `?page=${menuId}` });
    setSelectedMenu(menuId);
  };

  // ── React to browser back/forward ──────────────────────────────
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get("page") || "dashboard";
    setSelectedMenu(page);
  }, [location.search]);

  const handleMenuClick = (id) => {
    navigateTo(id);
    if (isMobile) setMobileOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <UserSidebar
        lang={lang}
        theme={theme}
        isMobile={isMobile}
        selectedMenu={selectedMenu}
        mobileOpen={mobileOpen}
        handleDrawerToggle={() => setMobileOpen(!mobileOpen)}
        handleMenuClick={handleMenuClick}
        isDark={isDark}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { xs: "100%", md: `calc(100% - ${drawerWidth}px)` },
          mt: { xs: 7, md: 0 },
        }}
      >
        <UserTopBar
          theme={theme}
          isMobile={isMobile}
          isDark={isDark}
          selectedMenu={selectedMenu}
          toggleColorMode={toggleColorMode}
          handleDrawerToggle={() => setMobileOpen(!mobileOpen)}
        />
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <UserContent selectedMenu={selectedMenu} />
        </Box>
      </Box>
    </Box>
  );
};

export default UserDashboard;
